//微信用户登录专用页

<template></template>
<script>
import { wxLogin, wxMenu } from "../../assets/js/url";

export default {
  data: function() {
    return {
      userCacheName: "UUID",
      hashName: "thePostHashKey",
      expiresTime: 1800000,	//超时时间（ms）
      randomStr: ""
    };
  },
  
  activated() {
    let key = this.$route.query.key;
	let menuOpt = this.$route.query.opt;
	let gotoScan = this.$route.query.gotoScan;
	let scanType = this.$route.query.type;				//"signIn" or "addTerminal"
	
	//alert("key="+key + ";menuOpt=" + menuOpt + ";gotoScan=" + gotoScan +";scanType=" + scanType);
	
    window.sessionStorage.setItem("login", "wechat"); 	//区分微信登陆还是一般登陆
	window.sessionStorage.setItem("wx_key", key);
	if(gotoScan){
		//去向扫码签到或扫终端码入会，如果当前是iPhone且在微信app中，因为iphone微信中，不能调用摄像头，所以提示用户"使用浏览器打开"
		//如果不是iphone且微信app中，则直接到扫码页
		
		let ua = window.navigator.userAgent.toLowerCase();
		//alert(ua);
		if(ua.indexOf('iphone') != -1 && ua.indexOf("micromessenger") != -1){
			//iPhone且在微信app中,当前不支持扫码,提示用 Safari 打开
			alert('请点击菜单“在Safari中打开”以调用摄像头扫描二维码');
		}
		else{
			if(window.sessionStorage.getItem("UUID")){
				//支持扫码且已登录，直接去到扫码页
				this.jumpRoute(menuOpt, scanType);
			}
			else{
				//支持扫码但未登录，先登录，再去到扫码页
				this.getWechat(key, menuOpt, scanType);
			}
		}
	}
	else{
		this.getWechat(key, menuOpt);
	}
  },

  methods: {
    //封装后端接口调用方法

    getWechat(key, menuOpt, scanType) {
      this.$http.post(wxLogin, { key: key }).then(res => {
        if (res.data.status == 2000) {
          console.log(res.data);
          var userInfo = res.data.data;
          window.sessionStorage.setItem("UUID", userInfo.useruuid); //将uuid设置到本地缓存中
		  window.sessionStorage.setItem('Time', userInfo.sync_now_meeting_each_seconds);
          window.sessionStorage.setItem("userStatus", userInfo.admin_level); //
          window.sessionStorage.setItem("flat", "1"); //微信平台=1
          window.sessionStorage.setItem('JSESSIONID', userInfo.sid);
		  window.localStorage.setItem('pageTitle', userInfo.entSettingInfo.pageTitle);
		  window.localStorage.setItem('bannerMobile', userInfo.entSettingInfo.bannerMobile);
		  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
              window.sessionStorage.setItem(
                "downUrl",
                userInfo.endpoint_software_ios_download_url
              );
          } else if (/(Android)/i.test(navigator.userAgent)) {
              window.sessionStorage.setItem(
                "downUrl",
                userInfo.endpoint_software_andriod_download_url
              );
          }
          this.jumpRoute(menuOpt, scanType);
        } 
      });
    },


    jumpRoute(menuOpt, scanType) {
	  //alert("jumpRoute, menuOpt=" + menuOpt + ";scanType=" + scanType);
	  if(scanType && scanType != ""){
		if(scanType=="signIn"){
			this.controlRouter("Sxt?type="+scanType);
		}
		else if(scanType=="addTerminal"){
			let meetingId = this.$route.query.meetingId;
			this.controlRouter("Sxt?type="+scanType+"&meetingId="+meetingId);
		}
	  }
      else if (menuOpt == "schedule") {
        this.controlRouter("attendmeeting");
      } else {
        this.controlRouter("index");
      }
    },
	
    controlRouter(route) {
      this.$router.push("/" + route);
    },

  }
};

</script>


// WEBPACK FOOTER //
// src/components/login/wxLogin.vue